import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractValidatingCarrier'
})
export class ExtractValidatingCarrierPipe implements PipeTransform {

  transform(data: any): string[] {
    const result: Set<string> = new Set();
    this.extractCarrier(data, result);
    return Array.from(result); // Convert Set back to an array
  }
  
  private extractCarrier(item: any, result: Set<string>): void {
    if (Array.isArray(item)) {
      item.forEach((subItem) => this.extractCarrier(subItem, result));
    } else if (typeof item === 'object' && item !== null) {
      // Check for both 'validatingcarrier' and 'marketing_carrier'
      if (item.hasOwnProperty('validatingcarrier')) {
        result.add(item.validatingcarrier);
      }
      if (item.hasOwnProperty('marketing_carrier')) {
        result.add(item.marketing_carrier);
      }
  
      // Continue traversing the object
      Object.values(item).forEach((value) => this.extractCarrier(value, result));
    }
  }

}
